<div class="result-modal" [ngClass]="'res-' + intent">

  <button type="button" class="close-btn" (click)="onDone()" aria-label="Close">
    <i class="bi bi-x-lg"></i>
  </button>

  <div class="result-body">
    <div class="result-ico" *ngIf="!data?.image">
      <i class="bi" [ngClass]="iconClass"></i>
    </div>
    <img class="result-image" *ngIf="data?.image" [src]="data.image" alt="" />

    <h3 class="result-title" *ngIf="data?.title">{{ data.title }}</h3>
    <p class="result-message">{{ data.message }}</p>
  </div>

  <div class="result-actions">
    <button type="button" class="btn btn-secondary" *ngIf="data?.secondaryAction" (click)="onSecondary()">
      {{ data.secondaryAction }}
    </button>
    <button type="button" class="btn btn-primary" (click)="onDone()">Done</button>
  </div>
</div>
